<template>
    <v-col
        cols="12"
        sm="12"
        md="6"
        lg="4"
        class="pa-0"
        tile
    >
        <v-card
            light
            outlined
            tile
            color="#fff"
        >
            <v-card-title class="w-100">
                <span class="text-h6 font-weight-light">Jobs</span>
                <v-spacer></v-spacer>
                <div class="text-end pa-2">
                    <v-select
                        v-model="filter.range"
                        :items="items"
                        label="Date Range"
                        dense
                        width="100"
                        hide-details
                        @change="getData"
                    ></v-select>
                </div>
            </v-card-title>

            <v-card-text>
                <LineChartGenerator
                    v-if="loaded"
                    :chart-options="chartOptions"
                    :chart-data="chartData"
                    :chart-id="chartId"
                    :dataset-id-key="datasetIdKey"
                    :plugins="plugins"
                    :css-classes="cssClasses"
                    :styles="styles"
                    :width="width"
                    :height="height"
                />
            </v-card-text>

            <v-card-actions class="w-100 blue lighten-5">
                <v-list-item class="grow">
                    <v-row
                    align="center"
                    justify="start"
                    >
                        <v-icon class="mr-1" color="green" v-if="chartData.icon == 'mdi-arrow-up-bold'">
                            {{ chartData.icon }}
                        </v-icon>
                        <v-icon class="mr-1" color="red" v-else-if="chartData.icon == 'mdi-arrow-down-bold'">
                            {{ chartData.icon }}
                        </v-icon>
                        <span class="subheading mr-2" v-if="chartData.percentage != 'Insufficient Data'">
                            <ICountUp
                            :delay="delay"
                            :endVal="chartData.percentage"
                            :options="options"
                            /> New Contracts
                        </span>
                        <span class="subheading mr-2" v-else>{{ chartData.percentage }}</span>
                    </v-row>
                    <v-spacer></v-spacer>
                    <v-row
                    align="center"
                    justify="end"
                    >
                        <v-icon class="mr-1" color="green" v-if="chartData.completed_icon == 'mdi-arrow-up-bold'">
                            {{ chartData.completed_icon }}
                        </v-icon>
                        <v-icon class="mr-1" color="red" v-else-if="chartData.completed_icon == 'mdi-arrow-down-bold'">
                            {{ chartData.completed_icon }}
                        </v-icon>
                        <span class="subheading mr-2" v-if="chartData.completed_percentage != 'Insufficient Data'">
                            <ICountUp
                            :delay="delay"
                            :endVal="chartData.completed_percentage"
                            :options="options"
                            /> Completed                        
                        </span>
                        <span class="subheading mr-2" v-else>{{ chartData.completed_percentage }}</span>
                    </v-row>
                </v-list-item>
            </v-card-actions>

        </v-card>
    </v-col>
</template>

<script>
import axios from 'axios'
import ICountUp from 'vue-countup-v2'
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {
    name: 'LineChart',
    components: {
        LineChartGenerator,
        ICountUp
    },
    props: {
        chartId: {
            type: String,
            default: 'line-chart'
        },
        datasetIdKey: {
            type: String,
            default: 'label'
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 400
        },
        cssClasses: {
            default: '',
            type: String
        },
        styles: {
            type: Object,
            default: () => {}
        },
        plugins: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loaded: false,
            items: ['7 Days', '30 Days', '6 Months', '12 Months'],
            filter: {
                range: '7 Days',
            },
            chartData: null,
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false
            },
            percentage: '',
            completed_percentage: '',
            icon: '',
            completed_icon: '',
            delay: 1000,
            options: {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: '%'
            },
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        async getData() {
            this.loaded = false

            try {
                await axios.get('crm/jobs/chart', {
                    params: this.filter
                })
                .then(response => {
                    this.loaded = true
                    this.chartData = response.data
                    this.$nextTick()
                })
            } catch (e) {
                console.error(e)
            }
        },
    }
}
</script>